import * as React from 'react';
import * as _ from 'underscore';

import StringField from '../StringField';

export default function ExchageObjectField(props: { value?: string; onChange?(value: string): void }) {
    return (
        <div className="variable-field">
            <table>
                <tbody>
                    <tr>
                        <td className="cell-variable-mark border-0">
                            <span className="glyphicon glyphicon-retweet"></span>
                        </td>

                        <td className="cell-variable-name border-0">
                            <StringField value={props.value} onChange={props.onChange} />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
